import React from "react";
import { Box, Text, Flex, SimpleGrid, Grid } from "@chakra-ui/react";
import Banner from "../../assets/homeImage/banner.png";
import GradientTextWithStroke from "../../components/StyledText/StyledText";
import TextBG from "../../assets/homeImage/text-bg.png";

// Gradient border style for each FAQ box
const cardStyle = {
  position: "relative",
  bg: "#3A005E",
  p: { base: 4, md: 6 },
  borderRadius: "10px",
   position: "relative",
  overflow: "hidden",
  bgImage: `url(${TextBG})`,
  bgSize: "cover",
  bgPosition: "center",
  bgRepeat: "no-repeat",
  _before: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "10px",
    padding: "1px",
    background:
      "linear-gradient(235.22deg, rgba(255, 209, 153, 0.1) -31.4%, #FFD199 -12.83%, rgba(255, 209, 153, 0.1) 6.39%, #FFD199 24.96%, rgba(255, 209, 153, 0.1) 46.73%, #FFD199 69.15%, rgba(255, 209, 153, 0.1) 96.69%)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 1,
  },
};

const faqs = [
  {
    num: "1",
    title: "What Is Winnsta?",
    desc: "Winnsta is a comprehensive online gaming platform offering a variety of games, including Fantasy Sports (Cricket, Football, Kabaddi), Poker, Rummy, Teen Patti and more. It brings together fun, fair play, and practice, on a single platform, ensuring entertainment for all types of players.",
  },
  {
    num: "2",
    title: "Is The Platform Legal?",
    desc: "Yes. Winnsta operates legally in most Indian states as it offers only skill and chance. However, real money games are restricted in states like Assam, Sikkim, and a few places. Check your local regulations before playing.",
  },
  {
    num: "3",
    title: "How Do I Reset My Password?",
    desc: "• Navigate to the login screen.\n• Click on 'Forgot Password'.\n• Enter your registered email or mobile number.\n• Follow the instructions sent to your email or SMS to reset your password.",
  },
  // {
  //   num: "4",
  //   title: "How Do I Verify My KYC?",
  //   desc: "• Go to the 'Profile' section in the app.\n• Select 'KYC Verification'.\n• Upload the required documents:\n  (Proof of Identity, e.g., Aadhaar, PAN Card)\n  (Proof of Address e.g., Utility Bill, Bank Statement)\n• Admin team validates and verifies, which typically takes 24-48 hours.",
  // },
  // {
  //   num: "4",
  //   title: "How Do I Deposit Or Withdraw Funds?",
  //   desc: "Deposits:\n• Go to the 'Wallet' section.\n• Select 'Deposit'.\n• Choose your preferred payment method (UPI, Net Banking, Credit/Debit Card, etc.).\n• Enter the amount and complete the transaction.\nWithdrawals:\n• Navigate to the 'Wallet' section.\n• Select 'Withdraw'.\n• Enter the amount and bank details.\n• Submit the request. Withdrawals are processed within 24-72 hours.",
  // },
  // {
  //   num: "5",
  //   title: "What Is The Minimum Balance Required?",
  //   desc: "Minimum Deposit: ₹100\nMinimum Withdrawal: ₹200\nNote: These amounts may vary based on ongoing promotions or specific game requirements.",
  // },
];

const FAQ = () => {
  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        color="white"
      >
        <Flex direction="column" alignItems={"end"} h="100%" width="95%" pt="150px">
          <Box textAlign="center">
            <GradientTextWithStroke
              text="Frequently Asked Questions"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
              ml="100px"
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mt="-10px"
            >
              {/* Winnsta Gaming Galaxy - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      <Box bg="#3A005E" px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        {/* General Section */}
        <Text
          textAlign="center"
          fontSize={{ base: "20px", md: "30px" }}
          color="#FFFFFF"
          mb={4}
        >
          General
        </Text>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
          {faqs.slice(0, 2).map((faq) => (
            <Box key={faq.num} {...cardStyle}>
              <Flex align="center" gap={3} mb={2} wrap="nowrap">
                <Box
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  {faq.num}
                </Box>
                <Text
                  color="#FFD199"
                  fontWeight="bold"
                  fontSize={{ base: "18px", md: "24px" }}
                  flex="1"
                >
                  {faq.title}
                </Text>
              </Flex>
              <Text
                whiteSpace="pre-line"
                color="#A1A1A1"
                fontSize={{ base: "16px", md: "20px" }}
              >
                {faq.desc}
              </Text>
            </Box>
          ))}
        </SimpleGrid>

        {/* Account Related */}
        <Text
          textAlign="center"
          fontSize={{ base: "20px", md: "30px" }}
          color="#FFFFFF"
          mb={4}
        >
          Account Related
        </Text>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
          {faqs.slice(2, 4).map((faq) => (
            <Box key={faq.num} {...cardStyle}>
              <Flex align="center" gap={3} mb={2} wrap="nowrap">
                <Box
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  {faq.num}
                </Box>
                <Text
                  color="#FFD199"
                  fontWeight="bold"
                  fontSize={{ base: "18px", md: "24px" }}
                  flex="1"
                >
                  {faq.title}
                </Text>
              </Flex>
              <Text
                whiteSpace="pre-line"
                color="#A1A1A1"
                fontSize={{ base: "16px", md: "20px" }}
              >
                {faq.desc}
              </Text>
            </Box>
          ))}
        </SimpleGrid>

        {/* Wallet & Payments */}
        {/* <Text
          textAlign="center"
          fontSize={{ base: "20px", md: "30px" }}
          color="#FFFFFF"
          mb={4}
        >
          Wallet & Payments
        </Text> */}
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
          {faqs.slice(4, 6).map((faq) => (
            <Box key={faq.num} {...cardStyle}>
              <Flex align="center" gap={3} mb={2} wrap="nowrap">
                <Box
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  {faq.num}
                </Box>
                <Text
                  color="#FFD199"
                  fontWeight="bold"
                  fontSize={{ base: "18px", md: "24px" }}
                  flex="1"
                >
                  {faq.title}
                </Text>
              </Flex>
              {/* Conditionally render colored sections for FAQ #5 */}
              {faq.num === "5" ? (
                <Box fontSize={{ base: "16px", md: "20px" }}>
                  <Text as="span" color="white">
                    Deposits:
                  </Text>
                  <Text as="span" color="#A1A1A1" whiteSpace="pre-line">
                    {
                      "\n• Go to the 'Wallet' section.\n• Select 'Deposit'.\n• Choose your preferred payment method (UPI, Net Banking, Credit/Debit Card, etc.).\n• Enter the amount and complete the transaction."
                    }
                  </Text>
                  <br />
                  <br />
                  <Text as="span" color="white">
                    Withdrawals:
                  </Text>
                  <Text as="span" color="#A1A1A1" whiteSpace="pre-line">
                    {
                      "\n• Navigate to the 'Wallet' section.\n• Select 'Withdraw'.\n• Enter the amount and bank details.\n• Submit the request. Withdrawals are processed within 24-72 hours."
                    }
                  </Text>
                </Box>
              ) : (
                <Text
                  whiteSpace="pre-line"
                  color="#A1A1A1"
                  fontSize={{ base: "16px", md: "20px" }}
                >
                  {faq.desc}
                </Text>
              )}
            </Box>
          ))}
        </SimpleGrid>

        {/* {add here} */}

        <Flex
          direction={{ base: "column", md: "row" }}
          gap={14}
          // px={{ base: 4, md: 8 }}
          py={6}
          // bg="#0E0D12"
          color="white"
          justify="center"
          align="stretch"
          flexWrap="wrap"
        >
          {/* Left Side - Winners Decided */}
          <Box
            sx={cardStyle}
            w={{ base: "100%", md: "800px" }}
            h={{ base: "auto", md: "643px" }}
            display="flex"
            flexDirection="column"
            px={{ base: 4, md: 6 }} // optional padding for clean left-alignment
          >
            {/* Title Row - LEFT ALIGNED */}
            <Flex align="center" gap={2} mb={4}>
              <Text fontWeight="bold" fontSize="30px" ml="20px" color={"#FFD199"}>
                <Text
                  as="span"
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  4
                </Text>{" "}
                How Are Winners Decided?
              </Text>
            </Flex>

            {/* CENTERED CONTENT */}
            <Box flex="1" display="flex" justifyContent="center">
              <Grid
                templateColumns={{ base: "1fr", md: "293px 360px" }}
                gap={8}
                placeItems="center"
              >
                {/* Left - Arcade Games (vertical) */}
                <Box
                  bg="linear-gradient(180deg, #FFD199 0%, #C98319 100%)"
                  borderRadius="md"
                  color="black"
                  p={2}
                  w={{base:"360px",md:"313px"}}
                  h="486px"
                >
                  <Text
                    mb={2}
                    fontSize={"35px"}
                    textAlign={"center"}
                    fontWeight={"500"}
                  >
                    Fantasy Sports:
                  </Text>
                  <Text
                    fontSize="28px"
                    textAlign="justify"
                    fontFamily={"barlow"}
                    color="#17161B"
                  >
                    Winners are determined based on the real-time performance of
                    selected players in actual matches. Points are allocated as
                    per the predefined scoring system.
                  </Text>
                </Box>

                {/* Right - Stacked Fantasy & Rummy */}
                <Flex direction="column" gap={6} align="center">
                  <Box
                    bg="linear-gradient(180deg, #FFD199 0%, #C98319 100%)"
                    borderRadius="md"
                    color="black"
                    p={2}
                    w="360px"
                    h="235px"
                  >
                    <Text
                      mb={2}
                      fontSize={"35px"}
                      textAlign={"center"}
                      fontWeight={"500"}
                    >
                      Poker & Rummy:
                    </Text>
                    <Text
                      fontSize="28px"
                      textAlign="justify"
                      fontFamily={"barlow"}
                      color="#17161B"
                    >
                      Winners are decided based on standard game rules and hand
                      rankings.
                    </Text>
                  </Box>

                  <Box
                    bg="linear-gradient(180deg, #FFD199 0%, #C98319 100%)"
                    borderRadius="md"
                    color="black"
                    p={2}
                    w="360px"
                    h="235px"
                  >
                    <Text
                      mb={"5px"}
                      fontSize={"35px"}
                      textAlign={"center"}
                      fontWeight={"500"}
                    >
                      Arcade Games:
                    </Text>
                    <Text
                      fontSize="28px"
                      textAlign="justify"
                      fontFamily={"barlow"}
                      color="#17161B"
                    >
                      Victory is achieved by meeting specific game objectives or
                      achieving the highest score.
                    </Text>
                  </Box>
                </Flex>
              </Grid>
            </Box>
          </Box>

          {/* Right Side - Fairness Ensured */}
          <Box
            sx={cardStyle}
            w={{ base: "100%", md: "550px" }}
            h={{ base: "auto", md: "643px" }}
          >
            <Flex align="center" gap={2} mb={4}>
              <Text fontWeight="bold" fontSize="30px" ml="20px" color="#FFD199">
                <Text
                  as="span"
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  5
                </Text>{" "}
                How is Fairness Ensured?
              </Text>
            </Flex>

            <Text fontSize="35px" color="#FFFFFF80"   textAlign="justify">
              Winnsta Gaming Galaxy uses certified random number generators
              (RNGs) for casual games and strict anti-fraud measures. All
              contests are monitored for fair play, and suspicious activity is
              investigated promptly to maintain a level playing field.
            </Text>
          </Box>
        </Flex>

<Box textAlign="center" px="4">
  <Text fontSize="35px" color="#fff" mb="8">
    Responsible Gaming
  </Text>

  <Box maxW="1405px" mx="auto">
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
      {/* Box 1 */}
      <Box sx={cardStyle} w="100%" h={{ base: "auto", md: "329px" }}>
        <Flex align="center" mb="3" position="relative" zIndex="2">
               <Text fontWeight="bold" fontSize="30px" ml="20px" color="#FFD199">
                <Text
                  as="span"
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  6
                </Text>{" "}
              Are There Time Limits To Prevent Excessive Gaming?
              </Text>
        </Flex>
        <Text
          fontSize="25px"
          color="#FFFFFF80"
          lineHeight="1.5"
          position="relative"
          zIndex="2"
            textAlign="justify"
        >
          Yes, players can set daily or weekly time limits in the "Responsible Gaming"
          section to manage their gaming activity. Notifications are sent as reminders
          when approaching set limits.
        </Text>
      </Box>

      {/* Box 2 */}
      <Box sx={cardStyle} w="100%" h={{ base: "auto", md: "329px" }}>
        <Flex align="center" mb="3" position="relative" zIndex="2">
            <Text fontWeight="bold" fontSize="30px" ml="20px" color="#FFD199">
                <Text
                  as="span"
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  7
                </Text>{" "}
               What Self-Exclusion Features Are Available? [Players Can Opt For:]
              </Text>
        </Flex>
        <Text
          fontSize="25px"
          color="#FFFFFF80"
          lineHeight="1.5"
          whiteSpace="pre-line"
          position="relative"
          zIndex="2"
            textAlign="justify"
        >
          Temporary Suspension: Deactivate the account for a chosen period.
          {"\n"}Permanent Closure: Close the account indefinitely.
          {"\n"}These options are accessible in the "Responsible Gaming" settings.
        </Text>
      </Box>
    </SimpleGrid>

    {/* Box 3 */}
    <Box sx={cardStyle} mt="6" w="100%" h={{ base: "auto", md: "205px" }}>
      <Flex align="center" mb="3" position="relative" zIndex="2">
          <Text fontWeight="bold" fontSize="30px" ml="20px" color="#FFD199">
                <Text
                  as="span"
                  fontFamily="Bungee"
                  color="white"
                  fontSize={{ base: "30px", md: "35px" }}
                  minW="40px"
                  textAlign="center"
                >
                  8
                </Text>{" "}
              Who Can I Contact For Support Or Help With Responsible Gaming?
              </Text>
      </Flex>
      <Text
        fontSize="25px"
        color="#FFFFFF80"
        lineHeight="1.5"
        position="relative"
        zIndex="2"
          textAlign="justify"
      >
        For support, visit the “Support” or “helpdesk” section in the app or website.
        You can also reach out to our customer care team via email or live chat for
        assistance with responsible gaming tools or any other queries.
      </Text>
    </Box>
  </Box>
</Box>


      </Box>
    </Box>
  );
};

export default FAQ;
